import { render, staticRenderFns } from "./WapHome.vue?vue&type=template&id=0a1d7f33&"
import script from "./WapHome.vue?vue&type=script&lang=js&"
export * from "./WapHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports